import { useNavigate } from 'react-router-dom';
import { useSelectedOrCurrentYear } from '../useYears';

export const CustomToast = () => {
  const navigate = useNavigate();
  const year = useSelectedOrCurrentYear();

  return (
    <div className="flex gap-2 items-center">
      <p>CSV出力をリクエストしました</p>
      <button
        onClick={() => {
          navigate(`/${year}/csv-download`);
        }}
        className="bg-darkblue_100 text-white rounded px-2 py-1"
      >
        確認
      </button>
    </div>
  );
};
